import activityOverview from './activity-overview'
import innovationFieldOverview from './innovation-field-overview'
import introductionVideo from './introductionVideo'
import trendradarOverview from './trendradar-overview'
import welcomeArea from './welcome-area'
import workspaceOverview from './workspace-overview'

export default {
    activityOverview,
    innovationFieldOverview,
    introductionVideo,
    trendradarOverview,
    welcomeArea,
    workspaceOverview
}
